import { useState } from 'react';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import CallCenterResidentComponent from './CallCenterResidentComponent';

import { CUSTOM } from '../Modal/modalTypes';

const CallCenterResidentContainer = (props) => {
  const { t } = useTransl();
  const {
    persons,
    accessPoint,
    openAccessPointForPerson,
    requirePhotoForVisitorLockout,
  } = props;

  const [modal, setModal] = useState({ type: null, data: null });

  const onModalShow = (type, data) => {
    setModal({ type, data });
  };

  const onModalClose = () => {
    setModal({ type: null, data: null });
  };

  const onOpenAccessPointForResident = (personId) => {
    openAccessPointForPerson(accessPoint, { id: personId });
    onModalClose();
  };

  const modalProps = {
    modal: {
      modalType: CUSTOM,
      modalProps: {
        title: t('callCenter.giveAccess'),
      },
    },
    onModalClose,
  };

  return (
    <CallCenterResidentComponent
      persons={persons}
      requirePhotoForVisitorLockout={requirePhotoForVisitorLockout}
      modal={modal}
      modalProps={modalProps}
      onModalShow={onModalShow}
      onOpenAccessPointForResident={onOpenAccessPointForResident}
    />
  );
};

CallCenterResidentContainer.propTypes = {
  persons: PropTypes.instanceOf(Array).isRequired,
  accessPoint: PropTypes.instanceOf(Object).isRequired,
  openAccessPointForPerson: PropTypes.func.isRequired,
  requirePhotoForVisitorLockout: PropTypes.bool.isRequired,
};

export default CallCenterResidentContainer;
